module.exports = __webpack_public_path__ + "static/media/no-stores.81e6ee96.png";